import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var cart = {

    selectors: {
        form: 'form.cart',
        variationForm: 'form.variations_form',
        quantity: '.quantity'
    },

    init: function() {
        var self = this;

        self.variationSelect();
        self.quantityInput();
        self.ajaxAddToCart();
        self.minicart();

        $( document ).on( 'facetwp-loaded', function() {
            //Refresh basic add to cart button
            if ( typeof wc_add_to_cart_params === 'undefined' ) {
                new AddToCartHandler();
            }

            //Init WC variations form
            $( function() {
                if ( typeof wc_add_to_cart_variation_params !== 'undefined' ) {
                    $( self.selectors.variationForm ).each( function() {
                        $( this ).wc_variation_form();
                    });
                }
            } );
            
            //Refresh quantity input & add to cart button
            self.variationSelect();
            self.quantityInput();
            self.ajaxAddToCart();
        } );

        $( document.body ).on( 'updated_wc_div', function() {
            self.quantityInput();
        } );
    },

    variationSelect: function( refresh ) {
        var self = this;
        self.$selects = $( self.selectors.variationForm ).find( 'select' );

        self.$selects.chosen( {
            disable_search: true,
            placeholder_text_single: ''
        } );

        $( self.selectors.variationForm ).on( 'update_variation_values', function() {
            var $select = $( this ).find( 'select' );

            setTimeout( function () {
                $select.trigger( 'chosen:updated' );
            }, 250 );
        } );
    },

    quantityInput: function() {
        var self = this,
        $qty = $( self.selectors.quantity ),
        $qtyInput = $qty.find( 'input.qty' );

        //Reset all
        $qty.off( '.quantity' );

        $qty.on( 'click.quantity', '.plus', function( e ) {
            var $input = $( this ).siblings( 'input.qty' ),
            val = parseInt( $input.val() ),
            step = parseInt( $input.attr( 'step' ) ),
            max = parseInt( $input.attr( 'max' ) ) || 99;

            if ( ( val + step ) <= max ) {
                step = 'undefined' !== typeof( step ) ? parseInt( step ) : 1;
                $input.val( val + step ).change();
            }
        } );

        $qty.on( 'click.quantity', '.minus', function() {
            var $input = $( this ).siblings( 'input.qty' );
            var val = parseInt( $input.val() );
            var step = parseInt( $input.attr( 'step' ) );
            step = 'undefined' !== typeof( step ) ? parseInt( step ) : 1;
            if ( val > 0 ) {
                $input.val( val - step ).change();
            }
        } );
    },

    ajaxAddToCart: function() {
        var self = this,
        $formElements = $( self.selectors.form );

        $formElements.each( function() {
            var $formElement = $( this );

            var $submitButton = $formElement.find( '.single_add_to_cart_button' ),
            $quantityInput = $formElement.find( 'input.qty' ),
            $variationInput = $formElement.find( 'input[name="variation_id"]' );

            var quantity = $quantityInput.val() !== undefined ? $quantityInput.val() : 1;
            var productID = $submitButton.val();

            if ( $formElement.hasClass( 'variations_form' ) ) {
                productID = $variationInput.val();
            }

            $submitButton.addClass( 'add_to_cart_button ajax_add_to_cart' );

            if ( productID != 0 ) {
                $submitButton.data( 'product_id', productID );
                $submitButton.attr( 'data-product_id', productID );
            }

            $submitButton.data( 'quantity', quantity );
            $submitButton.attr( 'data-quantity', quantity );

            //Reset all
            $variationInput.off( '.bd-cart' );
            $quantityInput.off( '.bd-cart' );
            $submitButton.off( '.bd-cart' );
            $( document.body ).off( '.bd-cart' );

            $variationInput.on( 'change.bd-cart', function() {
                productID = $( this ).val();
                $submitButton.data( 'product_id', productID );
                $submitButton.attr( 'data-product_id', productID );
            } );

            $quantityInput.on( 'change.bd-cart', function( e ) {
                var updatedQuantity = $( this ).val();
                $submitButton.data( 'quantity', updatedQuantity );
                $submitButton.attr( 'data-quantity', updatedQuantity );
            } );

            $submitButton.on( 'click.bd-cart', function( e ) {
                if ( $( this ).is('.disabled') === false ) {
                    e.preventDefault();
                    $( document.body ).addClass( 'adding-to-cart' );
                }
            } );

        } );

        $( document.body ).on( 'added_to_cart.bd-cart', function() {
            $( document.body ).removeClass( 'adding-to-cart' );
        } );
    },

    minicart: function() {
        var minicart = document.querySelector( '.mini-cart' );

        $( '[data-cart-trigger]' ).on( 'click', function(e) {
            if ( $( minicart ).hasClass( 'mini-cart--empty' ) === false && $( document.body ).hasClass( 'template-cart' ) === false && $( document.body ).hasClass( 'template-checkout' ) === false ) {
                e.preventDefault();
            
                $( document.body ).addClass( 'mini-cart-opened' );

                disableBodyScroll( minicart );
                Scrollbar.init(document.querySelector( '.mini-cart__content' ) );
            }
        } );

        $( document.body ).on( 'added_to_cart', function() {
            setTimeout( function() {
                $( document.body ).addClass( 'mini-cart-opened' );

                disableBodyScroll( minicart );
                Scrollbar.init(document.querySelector( '.mini-cart__content' ) );
            }, 500 );
        } );

        $( '.site__overlay' ).on( 'click', function() {
            $( document.body ).removeClass( 'mini-cart-opened' );

            enableBodyScroll( minicart );
            Scrollbar.destroy( document.querySelector( '.mini-cart__content' ) );
        } );

        $( document.body ).on( 'click', '[data-cart-close]', function() {
            $( document.body ).removeClass( 'mini-cart-opened' );

            enableBodyScroll( minicart );
            Scrollbar.destroy( document.querySelector( '.mini-cart__content' ) );
        } );
    }

}

export {
    cart
};
